import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "sidebar-filters" }
const _hoisted_2 = { class: "sidebar-header" }
const _hoisted_3 = { class: "filters-container" }
const _hoisted_4 = { class: "accordion-title-wrapper" }
const _hoisted_5 = { class: "accordion-title-text" }
const _hoisted_6 = { class: "accordion-item-content" }
const _hoisted_7 = {
  key: 0,
  class: "filter-group-inner"
}
const _hoisted_8 = { class: "filter-input" }
const _hoisted_9 = { class: "filter-input" }
const _hoisted_10 = {
  key: 1,
  class: "filter-group-inner"
}
const _hoisted_11 = { class: "filter-input" }
const _hoisted_12 = { class: "filter-input" }
const _hoisted_13 = { class: "filter-input" }
const _hoisted_14 = {
  key: 2,
  class: "filter-group-inner"
}
const _hoisted_15 = { class: "filter-input" }
const _hoisted_16 = { class: "filter-input" }
const _hoisted_17 = { class: "filter-input" }
const _hoisted_18 = {
  key: 3,
  class: "filter-group-inner"
}
const _hoisted_19 = { class: "filter-input" }
const _hoisted_20 = { class: "filter-input" }
const _hoisted_21 = { class: "filter-input" }
const _hoisted_22 = {
  key: 4,
  class: "filter-group-inner"
}
const _hoisted_23 = { class: "filter-input" }
const _hoisted_24 = { class: "filter-input" }
const _hoisted_25 = { class: "sidebar-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxDateBox = _resolveComponent("DxDateBox")!
  const _component_DxTextBox = _resolveComponent("DxTextBox")!
  const _component_DxDropDownOptions = _resolveComponent("DxDropDownOptions")!
  const _component_DxLookup = _resolveComponent("DxLookup")!
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxDropDownBox = _resolveComponent("DxDropDownBox")!
  const _component_DxAccordion = _resolveComponent("DxAccordion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "header-left" }, [
        _createElementVNode("i", { class: "dx-icon-filter icon-main" }),
        _createElementVNode("span", { class: "sidebar-title" }, "Filtre")
      ], -1)),
      _createVNode(_component_DxButton, {
        icon: "close",
        "styling-mode": "text",
        class: "close-sidebar-btn-small",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close-sidebar')))
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_DxAccordion, {
        items: $data.accordionItems,
        multiple: false,
        collapsible: true,
        "selected-item-keys": $data.selectedAccordionKeys,
        "onUpdate:selectedItemKeys": _cache[6] || (_cache[6] = ($event: any) => (($data.selectedAccordionKeys) = $event)),
        "key-expr": "id",
        class: "filters-accordion"
      }, {
        title: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("i", {
              class: _normalizeClass(data.icon)
            }, null, 2),
            _createElementVNode("span", _hoisted_5, _toDisplayString(data.title), 1)
          ])
        ]),
        item: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_6, [
            (data.id === 'date')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_DxDateBox, {
                      "show-clear-button": true,
                      type: "date",
                      "display-format": "dd-MM-yyyy",
                      label: "De la",
                      "label-mode": "floating",
                      value: $data.dataDocStart,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (($data.dataDocStart) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_DxDateBox, {
                      "show-clear-button": true,
                      type: "date",
                      "display-format": "dd-MM-yyyy",
                      label: "Până la",
                      "label-mode": "floating",
                      value: $data.dataDocEnd,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (($data.dataDocEnd) = $event))
                    }, null, 8, ["value"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (data.id === 'document')
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[8] || (_cache[8] = _createElementVNode("label", { class: "group-label" }, "Serie/Număr", -1)),
                    _createVNode(_component_DxTextBox, {
                      value: $data.tbSerie,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (($data.tbSerie) = $event)),
                      placeholder: "Serie document...",
                      "label-mode": "floating",
                      label: "Serie"
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_DxLookup, {
                      "data-source": $data.dsCategorieDocumente,
                      "display-expr": "Nume",
                      "value-expr": "Id",
                      "label-mode": "floating",
                      label: "Categorie",
                      "show-clear-button": true,
                      "search-enabled": true,
                      onValueChanged: $options.onValueChangedCategorie
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxDropDownOptions, { "show-title": false })
                      ]),
                      _: 1
                    }, 8, ["data-source", "onValueChanged"])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_DxLookup, {
                      ref: "tipDocumentLookup",
                      "data-source": $data.dsTipDocumente,
                      "display-expr": "Nume",
                      "value-expr": "Id",
                      "label-mode": "floating",
                      label: "Tip Document",
                      "show-clear-button": true,
                      "search-enabled": true,
                      value: $data.sTipDocumente,
                      onValueChanged: $options.onValueChangedTipDocument
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxDropDownOptions, { "show-title": false })
                      ]),
                      _: 1
                    }, 8, ["data-source", "value", "onValueChanged"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (data.id === 'partners')
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_DxLookup, {
                      "data-source": $data.dsGrupePartener,
                      "display-expr": "Nume",
                      "value-expr": "Id",
                      "label-mode": "floating",
                      label: "Grup Parteneri",
                      "show-clear-button": true,
                      "search-enabled": true,
                      value: $data.GrupaPartenerID,
                      onValueChanged: $options.onValueChangedGrupePartener
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxDropDownOptions, { "show-title": false })
                      ]),
                      _: 1
                    }, 8, ["data-source", "value", "onValueChanged"])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_DxLookup, {
                      "data-source": $data.dsZone,
                      "display-expr": "Nume",
                      "value-expr": "Id",
                      "label-mode": "floating",
                      label: "Zona",
                      "show-clear-button": true,
                      "search-enabled": true,
                      onValueChanged: $options.onValueChangedZone
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxDropDownOptions, { "show-title": false })
                      ]),
                      _: 1
                    }, 8, ["data-source", "onValueChanged"])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_DxDropDownBox, {
                      ref: "partenerLookup",
                      "data-source": $data.dsPartener,
                      "show-clear-button": true,
                      placeholder: "Partener",
                      "label-mode": "floating",
                      label: "Partener",
                      "display-expr": $options.partenerDisplayExpr,
                      "value-expr": "ID",
                      onValueChanged: $options.onPartenerValueChanged
                    }, {
                      content: _withCtx(({ data }) => [
                        _createVNode(_component_DxDataGrid, {
                          "data-source": $data.dsPartener,
                          columns: ['CUI', 'Nume'],
                          "hover-state-enabled": true,
                          onSelectionChanged: $options.onValueSelectedPartener,
                          height: "100%"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxSelection, { mode: "single" }),
                            _createVNode(_component_DxPaging, {
                              enabled: true,
                              "page-size": 5
                            }),
                            _createVNode(_component_DxFilterRow, { visible: true }),
                            _createVNode(_component_DxSearchPanel, {
                              visible: true,
                              placeholder: "Cauta ..."
                            })
                          ]),
                          _: 1
                        }, 8, ["data-source", "onSelectionChanged"])
                      ]),
                      _: 2
                    }, 1032, ["data-source", "display-expr", "onValueChanged"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (data.id === 'references')
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_DxDropDownBox, {
                      ref: "proiectLookup",
                      "data-source": $data.dsProiect,
                      "show-clear-button": true,
                      placeholder: "Proiect",
                      "label-mode": "floating",
                      label: "Proiect",
                      "display-expr": $options.proiectDisplayExpr,
                      "value-expr": "Id",
                      onValueChanged: $options.onProiectValueChanged
                    }, {
                      content: _withCtx(({ data }) => [
                        _createVNode(_component_DxDataGrid, {
                          "data-source": $data.dsProiect,
                          columns: ['Cod', 'Nume'],
                          "hover-state-enabled": true,
                          onSelectionChanged: $options.onValueSelectedProiect,
                          height: "100%"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxSelection, { mode: "single" }),
                            _createVNode(_component_DxPaging, {
                              enabled: true,
                              "page-size": 5
                            }),
                            _createVNode(_component_DxFilterRow, { visible: true }),
                            _createVNode(_component_DxSearchPanel, {
                              visible: true,
                              placeholder: "Cauta ..."
                            })
                          ]),
                          _: 1
                        }, 8, ["data-source", "onSelectionChanged"])
                      ]),
                      _: 2
                    }, 1032, ["data-source", "display-expr", "onValueChanged"])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_DxDropDownBox, {
                      ref: "comandaLookup",
                      "data-source": $data.dsComanda,
                      "show-clear-button": true,
                      placeholder: "Comanda",
                      "label-mode": "floating",
                      label: "Comandă",
                      "display-expr": $options.comandaDisplayExpr,
                      "value-expr": "Id",
                      onValueChanged: $options.onComandaValueChanged
                    }, {
                      content: _withCtx(({ data }) => [
                        _createVNode(_component_DxDataGrid, {
                          "data-source": $data.dsComanda,
                          columns: ['Cod', 'Nume'],
                          "hover-state-enabled": true,
                          height: "100%",
                          onSelectionChanged: $options.onValueSelectedComanda
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxSelection, { mode: "single" }),
                            _createVNode(_component_DxPaging, {
                              enabled: true,
                              "page-size": 5
                            }),
                            _createVNode(_component_DxFilterRow, { visible: true }),
                            _createVNode(_component_DxSearchPanel, {
                              visible: true,
                              placeholder: "Cauta ..."
                            })
                          ]),
                          _: 1
                        }, 8, ["data-source", "onSelectionChanged"])
                      ]),
                      _: 2
                    }, 1032, ["data-source", "display-expr", "onValueChanged"])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_DxLookup, {
                      ref: "agentLookup",
                      "data-source": $data.dsAgent,
                      "display-expr": "Nume",
                      "value-expr": "Id",
                      "label-mode": "floating",
                      label: "Agent",
                      "show-clear-button": true,
                      "search-enabled": true,
                      value: $data.sAgent,
                      onValueChanged: $options.onValueChangedAgent
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxDropDownOptions, { "show-title": false })
                      ]),
                      _: 1
                    }, 8, ["data-source", "value", "onValueChanged"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (data.id === 'products')
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _cache[9] || (_cache[9] = _createElementVNode("label", { class: "group-label" }, "Produs (Cod/Nume)", -1)),
                    _createVNode(_component_DxTextBox, {
                      value: $data.tbProdus,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (($data.tbProdus) = $event)),
                      placeholder: "Cauta produs...",
                      "label-mode": "floating"
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_DxLookup, {
                      "data-source": $data.dsCategorieProdus,
                      "display-expr": "Nume",
                      "value-expr": "Id",
                      "label-mode": "floating",
                      label: "Categorie Produs",
                      "show-clear-button": true,
                      "search-enabled": true,
                      value: $data.sCategorieProdus,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (($data.sCategorieProdus) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxDropDownOptions, { "show-title": false })
                      ]),
                      _: 1
                    }, 8, ["data-source", "value"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["items", "selected-item-keys"]),
      _createElementVNode("div", _hoisted_25, [
        _createVNode(_component_DxButton, {
          text: "Caută",
          type: "default",
          icon: "search",
          onClick: $options.Cautare,
          class: "sidebar-search-btn"
        }, null, 8, ["onClick"])
      ])
    ])
  ]))
}